/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindCanonicalValueByCustomFieldValueIdQueryResponse,
  FindCanonicalValueByCustomFieldValueIdPathParams,
} from "../types/FindCanonicalValueByCustomFieldValueId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCanonicalValueByCustomFieldValueIdQueryKey = (
  customFieldValueId:
    | FindCanonicalValueByCustomFieldValueIdPathParams["customFieldValueId"]
    | undefined
) =>
  [
    {
      url: "/v1/datapoint/find-canonical-value/custom-field/:customFieldValueId",
      params: { customFieldValueId: customFieldValueId },
    },
  ] as const

export type FindCanonicalValueByCustomFieldValueIdQueryKey = ReturnType<
  typeof findCanonicalValueByCustomFieldValueIdQueryKey
>

/**
 * @summary Resolve canonical datapoint value for a custom field value
 * {@link /v1/datapoint/find-canonical-value/custom-field/:customFieldValueId}
 */
export async function findCanonicalValueByCustomFieldValueId(
  customFieldValueId: FindCanonicalValueByCustomFieldValueIdPathParams["customFieldValueId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCanonicalValueByCustomFieldValueIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/datapoint/find-canonical-value/custom-field/${customFieldValueId}`,
    ...requestConfig,
  })
  return res
}

export function findCanonicalValueByCustomFieldValueIdQueryOptions(
  customFieldValueId:
    | FindCanonicalValueByCustomFieldValueIdPathParams["customFieldValueId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey =
    findCanonicalValueByCustomFieldValueIdQueryKey(customFieldValueId)
  return queryOptions<
    ResponseConfig<FindCanonicalValueByCustomFieldValueIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCanonicalValueByCustomFieldValueIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!customFieldValueId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findCanonicalValueByCustomFieldValueId(customFieldValueId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Resolve canonical datapoint value for a custom field value
 * {@link /v1/datapoint/find-canonical-value/custom-field/:customFieldValueId}
 */
export function useFindCanonicalValueByCustomFieldValueId<
  TData = ResponseConfig<FindCanonicalValueByCustomFieldValueIdQueryResponse>,
  TQueryData =
    ResponseConfig<FindCanonicalValueByCustomFieldValueIdQueryResponse>,
  TQueryKey extends QueryKey = FindCanonicalValueByCustomFieldValueIdQueryKey,
>(
  customFieldValueId:
    | FindCanonicalValueByCustomFieldValueIdPathParams["customFieldValueId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCanonicalValueByCustomFieldValueIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findCanonicalValueByCustomFieldValueIdQueryKey(customFieldValueId)

  const query = useQuery(
    {
      ...findCanonicalValueByCustomFieldValueIdQueryOptions(
        customFieldValueId,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
